module.exports = __webpack_public_path__ + "static/circle-7a3e31847d50b1bb0bcc85a83a40f3ae.png";